export default __webpack_public_path__ + "2dde53e638a276794605143585a4f98e.svg";